import React from "react";
import { Select } from "antd";
import styles from "./SelectContent.scss";
const SelectContent = ({
  id,
  options,
  isMobile,
  isShownDropdown,
  onChange,
  onBlur,
  onFocus,
  value,
  selectRef,
  placeholder,
  onSearch,
  getPopupContainer
}) => (
  <Select
    // @ts-ignore
    id={id}
    disabled={isMobile}
    className={isMobile ? styles.mobileContent : styles.desktopSelect}
    mode={isShownDropdown ? "multiple" : "default"}
    onChange={onChange}
    onBlur={onBlur}
    onFocus={onFocus}
    value={value || undefined}
    ref={selectRef}
    placeholder={placeholder}
    onSearch={onSearch}
    filterOption={false}
    notFoundContent={"Nema rezultata"}
    getPopupContainer={getPopupContainer}
  >
    {options.map((option, index) => (
      <Select.Option
        key={index /* eslint-disable-line */}
        value={option.value.toString()}
      >
        {option.title}
      </Select.Option>
    ))}
  </Select>
);

SelectContent.defaultProps = {
  value: "",
  options: [],
  isMobile: false
};

export default SelectContent;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiSelector/SelectContent/index.tsx